const createItemsReportThermal = (data, language, settings) => {
  // Ensure returns data exists
  const { items } = data;
  const returns = data.returns || { total_amount: 0, count: 0, percentage: 0 };
  
  // Check if returns data exists and has count property
  const hasReturns = returns && (
    (typeof returns.count !== 'undefined' && returns.count > 0) || 
    (typeof returns.total_amount !== 'undefined' && returns.total_amount > 0)
  );
  
  // Format date in Gregorian format (DD/MM/YYYY)
  const currentDate = new Date();
  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const year = currentDate.getFullYear();
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');
  
  const date = `${day}/${month}/${year}`;
  const time = `${hours}:${minutes}`;

  // Get paper dimensions from settings
  const { printing = {}, restaurant = {} } = settings || {};
  const paperWidth = printing?.paper_size || '80mm';
  const paperHeight = printing?.paper_height || 'auto';
  const fontSize = printing?.font_size || '8';

  // Calculate dimensions with space for text
  const pageWidth = parseInt(paperWidth);
  const contentWidth = pageWidth - 12; // Reduce margin to prevent right side cutoff
  
  // Parse height properly for CSS
  const parsedHeight = paperHeight === 'auto' ? 300 : parseInt(paperHeight.replace('mm', ''));

  // Use totals from summary data for consistency with the backend
  const totalQuantity = data.summary.total_items_sold;
  const totalRevenue = data.summary.total_revenue;

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        @page {
          margin: 0;
          size: ${pageWidth}mm ${parsedHeight}mm;
        }
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        body {
          font-family: 'Arial', sans-serif;
          font-size: ${fontSize}pt;
          width: ${contentWidth}mm;
          margin: 0 auto;
          padding: 2mm;
          direction: ${language === 'ar' ? 'rtl' : 'ltr'};
        }
        .header {
          text-align: center;
          margin-bottom: 3mm;
        }
        .title {
          font-size: ${parseInt(fontSize) + 2}pt;
          font-weight: bold;
          margin-bottom: 1mm;
        }
        .subtitle {
          font-size: ${fontSize}pt;
          margin-bottom: 1mm;
        }
        .date-time {
          font-size: ${fontSize}pt;
          margin-bottom: 2mm;
        }
        .divider {
          border-top: 1px dashed #000;
          margin: 2mm 0;
        }
        .summary {
          margin-bottom: 3mm;
        }
        .summary-item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 1mm;
        }
        .returns-section {
          margin: 2mm 0;
          padding: 1mm;
          border: 1px dashed #000;
        }
        .returns-title {
          font-weight: bold;
          text-align: center;
          margin-bottom: 1mm;
        }
        .items-table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 2mm;
        }
        .items-table th {
          text-align: ${language === 'ar' ? 'right' : 'left'};
          padding: 1mm 0;
          border-bottom: 1px solid #000;
          font-weight: bold;
        }
        .items-table td {
          padding: 1mm 0;
          border-bottom: 1px dashed #ccc;
        }
        .text-right {
          text-align: right;
        }
        .text-left {
          text-align: left;
        }
        .text-center {
          text-align: center;
        }
        .footer {
          margin-top: 3mm;
          text-align: center;
          font-size: ${parseInt(fontSize) - 1}pt;
        }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="title">${language === 'ar' ? restaurant?.name_ar || 'المطعم' : restaurant?.name || 'Restaurant'}</div>
        <div class="subtitle">${language === 'ar' ? 'تقرير المنتجات' : 'Items Report'}</div>
        <div class="date-time">${date} ${time}</div>
      </div>
      
      <div class="divider"></div>
      
      <div class="summary">
        <div class="summary-item">
          <span>${language === 'ar' ? 'عدد المنتجات:' : 'Total Items:'}</span>
          <span>${items.length}</span>
        </div>
        <div class="summary-item">
          <span>${language === 'ar' ? 'إجمالي الكمية المباعة:' : 'Total Quantity Sold:'}</span>
          <span>${totalQuantity}</span>
        </div>
        <div class="summary-item">
          <span>${language === 'ar' ? 'إجمالي المبيعات:' : 'Total Revenue:'}</span>
          <span>${parseFloat(totalRevenue).toFixed(2)}</span>
        </div>
      </div>
      
      ${hasReturns ? `
      <div class="returns-section">
        <div class="returns-title">${language === 'ar' ? 'ملخص المرتجعات' : 'Returns Summary'}</div>
        <div class="summary-item">
          <span>${language === 'ar' ? 'إجمالي المرتجعات:' : 'Total Returns Amount:'}</span>
          <span>${returns.total_amount.toFixed(2)}</span>
        </div>
        <div class="summary-item">
          <span>${language === 'ar' ? 'عدد الطلبات المرتجعة:' : 'Number of Returns:'}</span>
          <span>${returns.count}</span>
        </div>
        <div class="summary-item">
          <span>${language === 'ar' ? 'نسبة المرتجعات:' : 'Returns Percentage:'}</span>
          <span>${returns.percentage.toFixed(2)}%</span>
        </div>
      </div>
      ` : ''}
      
      <div class="divider"></div>
      
      <div class="items-section">
        <table class="items-table">
          <thead>
            <tr>
              <th style="width: 50%;">${language === 'ar' ? 'المنتج' : 'Item'}</th>
              <th style="width: 20%;">${language === 'ar' ? 'الكمية' : 'Qty'}</th>
              <th style="width: 30%;">${language === 'ar' ? 'المبيعات' : 'Revenue'}</th>
            </tr>
          </thead>
          <tbody>
            ${items.map(item => `
              <tr>
                <td>${language === 'ar' ? item.name_ar : item.name}</td>
                <td>${item.quantity_sold}</td>
                <td>${parseFloat(item.total_revenue).toFixed(2)}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
      
      <div class="divider"></div>
      
      <div class="footer">
        ${language === 'ar' ? 'شكراً لكم' : 'Thank You'}
      </div>
    </body>
    </html>
  `;
};

export default createItemsReportThermal;
